import api from './api';

const resource = 'MenuImport/';

export const upload = async (formData) => {
  return await api.post(resource + 'Upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const status = async (jobId) => {
  return await api.get(resource + 'Status?jobid=' + encodeURIComponent(jobId));
};

export const confirm = async (body) => {
  return await api.post(resource + 'Confirm', body);
};

export const list = async (companyId) => {
  return await api.get(
    resource + 'List?companyid=' + encodeURIComponent(companyId)
  );
};

const menuImportApi = { upload, status, confirm, list };

export default menuImportApi;
